import { either, isEmpty, isNil } from 'ramda'

export const noop = () => ({})

// Used for BigInt serialization - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/BigInt#use_within_json
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const replacer = (_: any, value: any) => {
  return typeof value === 'bigint' ? value.toString() : value
}

// Patches BigInt.prototype.toJSON for callers that stringify
// without an explicit replacer (e.g. Apollo).
let bigIntSerializationConfigured = false

export const configureBigIntSerialization = (): void => {
  if (bigIntSerializationConfigured || typeof BigInt === 'undefined') {
    return
  }

  bigIntSerializationConfigured = true

  Object.defineProperty(BigInt.prototype, 'toJSON', {
    value: function toJSON() {
      return this.toString()
    },
    configurable: true,
    writable: true,
  })
}

export const isNilOrEmpty = either(isNil, isEmpty)
